<template>
  <v-container fluid id="toolOrders">
    <v-row wrap justify="center">
      <v-col cols="11" xs="12" class="headline pb-0"
        >Tool Pickup Requests</v-col
      >
      <v-col cols="11" xs="12">
        <v-card>
          <v-tabs>
            <v-tab @click="pickupType('open')"
              >Open<span class="caption ml-1 grey--text"></span
            ></v-tab>
            <v-tab @click="pickupType('closed')">Closed</v-tab>
            <v-tab @click="pickupType('cancelled')">Cancelled</v-tab>
          </v-tabs>
          <v-divider></v-divider>
          <v-data-table
            :items="currentToolPickups"
            :loading="loadingPickups"
            loading-text="Loading....please wait."
            :headers="headers"
          >
            <template v-slot:item.orderNumber="{ item }">
              <span class="subtitle-2">#{{ item.orderNumber }}</span>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                small
                color="amber lighten-3"
                v-if="item.status == 'open'"
              >
                open
              </v-chip>
              <v-chip
                small
                color="red lighten-3"
                v-if="item.status == 'closed'"
              >
                closed
              </v-chip>
              <v-chip small v-if="item.status == 'cancelled'">
                cancelled
              </v-chip>
            </template>
            <template v-slot:item.orderDate="{ item }">{{
              item.orderDate.toDate() | moment("MMM Do [at] h:mma")
            }}</template>
            <template v-slot:item.viewOrder="{ item }">
              <v-btn
                color="primary"
                small
                outlined
                text
                :to="`/tools/pickups/${item.orderNumber}`"
                >view request</v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import fb from "@/main";
import { mapState } from "vuex";
export default {
  data() {
    return {
      type: "open",
      loadingPickups: true,
      toolPickups: [],
      headers: [
        {
          text: "Order",
          align: "left",
          value: "orderNumber",
        },
        {
          text: "Site Address",
          align: "left",
          value: "jobSite.street",
          sortable: true,
        },
        { text: "Ordered By", value: "fullName" },
        { text: "Type", value: "pickupType" },
        { text: "Status", value: "status" },
        { text: "Date", value: "orderDate" },
        { text: "", value: "viewOrder", align: "right" },
      ],
    };
  },
  computed: {
    currentToolPickups: function() {
      return this.toolPickups.filter((tpu) => tpu.status == this.type);
    },
    ...mapState(["user"]),
  },
  async created() {
    try {
      const toolPickups = await fb.db
        .collection("toolPickups")
        .where("orderedBy.uid", "==", this.user.uid)
        .orderBy("orderDate", "desc")
        .limit(50)
        .get();
      this.toolPickups = [];
      toolPickups.forEach((u) => {
        this.toolPickups.push({
          id: u.id,
          ...u.data(),
        });
      });
      this.loadingPickups = false;
    } catch (error) {
      console.log(error);
      alert("Error getting pickup requests");
      this.loadingPickups = false;
    }
  },
  methods: {
    pickupType(type) {
      this.type = type;
    },
  },
};
</script>
